export default __webpack_public_path__ + "static/task-illustration@2x-5fb452c8c3e022ef6d11c47ac0c7a900.png";